import { render, staticRenderFns } from "./ContactTableMenu.vue?vue&type=template&id=48c8e61d&"
import script from "./ContactTableMenu.vue?vue&type=script&lang=js&"
export * from "./ContactTableMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports